module.exports = __webpack_public_path__ + "static/fonts/Roboto-Light.46e48ce.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Light.ttf
// module id = 312
// module chunks = 1